const purchaseRouter = {
  path: '/dispute',
  component: () => import('@/layout'),
  redirect: '/dispute/introduce',
  children: [
    {
      path: 'introduce',
      name: 'DisputeIntroduce',
      meta: { title: '纠纷补偿申请介绍' },
      component: () =>
        import(/* webpackChunkName: "dispute" */ '@/pages/member/dispute/pages/introduce')
    },
    {
      path: 'release/:id',
      name: 'DisputeRelease',
      meta: { title: '申请纠纷补偿' },
      component: () =>
        import(/* webpackChunkName: "dispute" */ '@/pages/member/dispute/pages/release')
    },
    {
      path: 'release',
      name: 'DisputeRelease',
      meta: { title: '申请纠纷补偿' },
      component: () =>
        import(/* webpackChunkName: "dispute" */ '@/pages/member/dispute/pages/release')
    },
    {
      path: 'release/:id/:disputeId',
      name: 'DisputeEdit',
      meta: { title: '修改纠纷补偿' },
      component: () =>
        import(/* webpackChunkName: "dispute" */ '@/pages/member/dispute/pages/release')
    },
    {
      path: 'details/:id',
      name: 'DisputeDetails',
      meta: { title: '纠纷补偿详情' },
      component: () =>
        import(/* webpackChunkName: "dispute" */ '@/pages/member/dispute/pages/details')
    }
  ]
}

export default purchaseRouter
